// extracted by mini-css-extract-plugin
export default {"yoTabs":"YoTabs_yoTabs__isrvZ"};